export default __webpack_public_path__ + "static/media/BabyElephant.b039f255.jpg";